import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'slate_design_system-ui_button_click-click';
/**
 * Emitted when a Slate button is clicked
 */
export function trackSlateDesignSystemUiButtonClickClick(buttonId) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: true,
        parameters: { buttonId },
    });
}
